<!-- NAV BAR-->
<app-navbar></app-navbar>


<div class="container mt-5">
    <router-outlet></router-outlet>
</div>